import React from "react";
import Footer from "../Footer";
import Navbar from "../Navbar";
import PubBodyForm from "../pubformbody";
export default function PublicForm(){

    return(
      <div>
<Navbar />
<PubBodyForm />
<Footer />
      </div>

    )


}